import React, { useRef, useEffect, useState } from "react";
import NarrativeTooltip from "./NarrativeTooltip";

// Smart narrative card that only shows tooltip if text is truncated
const SmartNarrativeCard = ({ narrative }) => {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const checkTruncation = () => {
      if (textRef.current) {
        // Check if the element's scrollHeight is greater than its clientHeight
        // This indicates that content is being clipped/truncated
        const isOverflowing =
          textRef.current.scrollHeight > textRef.current.clientHeight;

        setIsTruncated(isOverflowing);
      }
    };

    // Single optimized check using RAF + timeout for better performance
    const rafId = requestAnimationFrame(() => {
      // Small delay to ensure CSS is fully applied
      setTimeout(checkTruncation, 50);
    });

    // Debounced resize handler for better performance
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(checkTruncation, 150);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      cancelAnimationFrame(rafId);
      clearTimeout(resizeTimeout);
      window.removeEventListener("resize", handleResize);
    };
  }, [narrative.text_content]);

  // Fallback check when hovering - in case initial checks missed truncation
  const handleHoverCheck = () => {
    if (!isTruncated && textRef.current) {
      const isOverflowing =
        textRef.current.scrollHeight > textRef.current.clientHeight;
      if (isOverflowing) {
        setIsTruncated(true);
      }
    }
  };

  const cardContent = (
    <div className="narrative-card" onMouseEnter={handleHoverCheck}>
      <p ref={textRef} className="narrative-text">
        {narrative.text_content}
      </p>
    </div>
  );

  // Only show tooltip if text is actually truncated
  if (isTruncated) {
    return (
      <NarrativeTooltip text={narrative.text_content}>
        {cardContent}
      </NarrativeTooltip>
    );
  }

  // If not truncated, just return the card without tooltip
  return cardContent;
};

export default SmartNarrativeCard;
